import React from 'react';

interface RedSliderSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  className?: string;
}

const RedSliderSwitch: React.FC<RedSliderSwitchProps> = ({
  checked,
  onChange,
  label = 'Red',
  className = '',
}) => {
  return (
    <label className={`inline-flex items-center cursor-pointer ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="sr-only peer"
      />
      <div
        className="relative w-7 h-4 bg-gray-200 rounded-full peer peer-checked:bg-[#D22630] 
        after:content-[''] after:absolute after:top-1/2 after:left-[2px] after:-translate-y-1/2 
        after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all 
        peer-checked:after:translate-x-3"
      ></div>
      {label && (
        <span className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{label}</span>
      )}
    </label>
  );
};

export default RedSliderSwitch;
